<template>
  <div
    class="row match-height"
    v-bind:class="{ fullscreen_expand: isFullscreen }"
  >
    <div class="col-xl-12 col-lg-12">
      <div class="card" style="">
        <div class="card-header">
          <h4 class="card-title">Gerais</h4>
          <a class="heading-elements-toggle"
            ><i
              class="fa fa-ellipsis-v font-medium-3"
              @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
            ></i
          ></a>
          <div
            class="heading-elements"
            v-bind:class="{
              visible: getSubMenuShowHideFw(),
              '': !getSubMenuShowHideFw(),
            }"
          >
            <ul class="list-inline mb-0">
              <li>
                <a @click="onFilterReset()" v-b-tooltip title="Atualizar Dados"
                  ><i class="ft-rotate-cw"></i
                ></a>
              </li>
              <li>
                <a
                  @click="expandFullscreen()"
                  v-b-tooltip
                  title="Expande a tela"
                  v-if="!isFullscreen"
                  ><i class="ft-maximize"></i
                ></a>
              </li>
              <li>
                <a
                  @click="expandFullscreen()"
                  v-b-tooltip
                  title="Minimiza a tela"
                  v-if="isFullscreen"
                  ><i class="ft-minimize"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-content">
          <div class="col-md-12">
            <b-row>
              <b-col>
                <b-form-text>Código da empresa </b-form-text>
                <b-form-input
                  type="text"
                  placeholder="Código"
                  v-model="form_config.cd"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_config.errors.get('cd')"
                  v-if="form_config.errors.has('cd')"
                ></b-form-feedback>
              </b-col>
              <b-col>
                <b-form-text>Nome</b-form-text>
                <b-form-input
                  type="text"
                  placeholder="Nome"
                  v-model="form_config.nome"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_config.errors.get('nome')"
                  v-if="form_config.errors.has('nome')"
                ></b-form-feedback>
              </b-col>

              <b-col>
                <b-form-text
                  >Pessoa Jurídica ( Matriz / Principal )</b-form-text
                >
                <multiselect
                  v-model="pessoaJuridicaSelected"
                  :options-limit="300"
                  :limit="2"
                  :limit-text="limitText"
                  :options="this.optionsPessoaJuridica"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Digite ao menos 3 caracteres"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                  :searchable="true"
                  :loading="isLoadingPeju"
                  @search-change="listaClientesPessoaJuridica"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_config.errors.get('pessoa.value')"
                  v-if="form_config.errors.has('pessoa.value')"
                ></b-form-feedback>
              </b-col>

              <b-col>
                <b-form-text>Pessoa Física Responsável</b-form-text>
                <multiselect
                  v-model="pessoaFisicaSelected"
                  :options-limit="300"
                  :limit="2"
                  :limit-text="limitText"
                  :options="this.optionsPessoaFisica"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Digite ao menos 3 caracteres"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                  :searchable="true"
                  :loading="isLoadingPefi"
                  @search-change="listaClientesPessoaFisica"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_config.errors.get('pefi.value')"
                  v-if="form_config.errors.has('pefi.value')"
                ></b-form-feedback>
              </b-col>

              <b-col>
                <b-form-text>Casas decimais </b-form-text>
                <b-form-input
                  type="number"
                  placeholder="Casas decimais"
                  v-model="form_config.decimais"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_config.errors.get('decimais')"
                  v-if="form_config.errors.has('decimais')"
                ></b-form-feedback>
              </b-col>

              <div>
                <div class="float-right" v-if="getPermission('conta.update')">
                  <b-btn
                    @click="onUpdateConta()"
                    style="margin: 16px; 15px 0 0"
                    variant="secondary"
                    :disabled="isDisabled"
                  >
                    Salvar mudanças
                  </b-btn>
                </div>
              </div>
            </b-row>
          </div>
        </div>
        <div class="table-responsive col-md-12">
          <h4 class="card-title">Dados do Plano</h4>
          <p>
            Você está usando o <b>{{ b_plano.descr }}</b> do BLogistic, que lhe
            da direito emitir
            <b
              >{{ b_plano.qtde_cte }} CTe(s), {{ b_plano.qtde_mdfe }} MDFe(s) e
              pode cadastrar {{ b_plano.qtde_unidade }} unidade(s)</b
            >
          </p>
          <a class="heading-elements-toggle"
            ><i
              class="fa fa-ellipsis-v font-medium-3"
              @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
            ></i
          ></a>
          <div
            class="heading-elements"
            v-bind:class="{
              visible: getSubMenuShowHideFw(),
              '': !getSubMenuShowHideFw(),
            }"
          ></div>
        </div>
        <div class="card-content">
          <div class="table-responsive col-md-12">
            <h4 class="card-title">Upgrade</h4>
            <b-row>
              <b-col>
                <label class="form-label"
                  >Selecione um dos Planos para fazer o upgrade</label
                >
                <multiselect
                  v-model="form_contato.b_plano"
                  :options="this.$parent.optionsBPlano"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Selecione"
                  open-direction="bottom"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_contato.errors.get('b_plano.value')"
                  v-if="form_contato.errors.has('b_plano.value')"
                ></b-form-feedback>
              </b-col>
            </b-row>
            <b-row>
              <div class="col-md-12">
                <label class="form-label">Mensagem</label>
              </div>
              <div class="col-md-12">
                <textarea
                  rows="8"
                  v-model="form_contato.mensagem"
                  class="form-control"
                >
                </textarea>
                <b-form-feedback
                  class="text-danger"
                  v-text="form_contato.errors.get('mensagem')"
                  v-if="form_contato.errors.has('mensagem')"
                ></b-form-feedback>
              </div>
            </b-row>
            <div>
              <div class="float-right">
                <b-btn
                  @click="enviaPlano()"
                  style="margin-top: 10px"
                  variant="secondary"
                  :disabled="isDisabled"
                >
                  Enviar
                </b-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueClipboard from "vue-clipboard2";
import ToggleButton from "vue-js-toggle-button";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

Vue.use(VueClipboard);
Vue.use(ToggleButton);
export default {
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      teste: "",
      isFullscreen: false,
      loading: false,
      disabled: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalPermission: false,
      pessoaFisicaSelected: [],
      pessoaJuridicaSelected: [],
      optionsPessoaFisica: [],
      optionsPessoaJuridica: [],
      isLoadingPeju: false,
      isLoadingPefi: false,
      form_config: new Form({
        cd: "",
        nome: "",
        pessoa: "",
        decimais: "",
        pefi_id: ""
      }),
      form_contato: new Form({
        mensagem: "",
        b_plano: [],
        email: "",
        ddd: "",
        numero: "",
        bcliente: "",
        plano_atual: ""
      }),
      helpForm: new Form({
        cep_busca: "",
        statusRecord: [],
        params: [],
        search: "",
      })
    };
  },
  watch: {
    pessoaFisicaSelected(obj) {
      this.form_config.pefi_id = obj.value;
    },
    pessoaJuridicaSelected(obj) {
      this.form_config.pessoa = obj.value;
    }
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
    this.$events.$on("reloadResponse", response =>
      this.onReloadResponse(response)
    );
    this.getDataConta();
  },
  methods: {
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    enviaPlano() {
      this.form_contato.email = this.user.email;
      this.form_contato.ddd = this.user.ddd;
      this.form_contato.numero = this.user.numero;
      this.form_contato.plano_atual = this.b_plano.descr;
      this.form_contato.bcliente = this.user.bcliente_active.nome;
      this.form_contato
        .post("/api/conta/contato")
        .then(response => {
          new ReturnApi(response, this);
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    getDataConta() {
      this.loadingData = true;
      this.form_config
        .get("/api/conta/conta")
        .then(response => {
          new ReturnApi(response, this);
          this.form_config.cd = response.data.cd;
          this.form_config.nome = response.data.nome;
          this.form_config.decimais = response.data.bConfigBlogistic.casasDecimais;
          this.pessoaFisicaSelected = {
            label: response.data.pessoaFisica.nome,
            value: response.data.pessoaFisica.pefiId
          };
          this.pessoaJuridicaSelected = {
            label: response.data.pessoaJuridica.razaoSocial,
            value: response.data.pessoaJuridica.pessoaId
          };
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
      this.loadingData = false;
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.id);
      }
    },
    onUpdateConta() {
      console.log(this.form_config);
      this.loading = true;
      this.isDisabled = true;
      this.form_config
        .post("/api/conta/update/conta")
        .then(response => {
          new ReturnApi(response, this);
          this.getDataConta();
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onReloadResponse(response) {
      new ReturnApi(response, this);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    listaClientesPessoaJuridica(search) {
      if (search.length >= 3) {
        this.isLoadingPeju = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlistpeju")
          .then(response => {
            this.optionsPessoaJuridica = [];
            new ReturnApi(response, this, true, false, false);
            response.peju.forEach(obj => {
              this.optionsPessoaJuridica.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id
              });
            });
            this.isLoadingPeju = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesPessoaFisica(search) {
      if (search.length >= 3) {
        this.isLoadingPefi = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlistpefi")
          .then(response => {
            this.optionsPessoaFisica = [];
            new ReturnApi(response, this, true, false, false);
              console.log(response);
            response.pefi.forEach(obj => {
              this.optionsPessoaFisica.push({
                label: obj.nome + " - " + obj.cpf,
                value: obj.pefi_id
              });
            });
            this.isLoadingPefi = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.logged.user;
      }
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>

<style>
</style>